import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { DeleteOutlined, LoadingOutlined } from '@ant-design/icons';
import { Button, Empty, Select } from 'antd';

import * as Actions from 'flex/Actions';

const { Option } = Select;

const EduMallSelect = ({
    edumallAppLists,
    form,
    name,
    onRemove,
}) => {
    const dispatch = useDispatch();
    const edumallSearchConnection = useSelector(state => state.edumallSearchConnection);
    const [input, setInput] = useState();
    const [searchValue, setSearchValue] = useState();
    const searchReservation = useRef(undefined);

    // optionが変更されたら全てのstateとrefをリセット（time lag解消）
    useEffect(() => {
        clearTimeout(searchReservation.current);
        searchReservation.current = undefined;
        setInput(undefined);
        setSearchValue(undefined);
    }, [name]);

    // コンポーネントアンマウント時のクリーンアップ
    useEffect(() => {
        return () => {
            clearTimeout(searchReservation.current);
            searchReservation.current = undefined;
        };
    }, []);

    // searchValueが変更されたらAPI呼び出し（setTimeout handlerから分離してviolation回避）
    useEffect(() => {
        if (!searchValue) return;

        dispatch(Actions.http.connection.edumall.search({
            contents_name: searchValue,
            page_size: 50,
        }));
    }, [searchValue, dispatch]);

    const handleSearch = value => {
        // 入力内容が削除された場合は、内容をリセット及び検索をキャンセル
        if(value === '') {
            handleSelect(undefined, {});
            clearTimeout(searchReservation.current);
            searchReservation.current = undefined;
            setSearchValue(undefined);
            return;
        }

        // 入力値を即座に表示してユーザーにレスポンシブな体験を提供（time lag削減）
        setInput(value);

        // 既存の検索予約をキャンセル
        clearTimeout(searchReservation.current);

        // setTimeout handlerは軽量なstate更新のみ実行（violation回避、time lag削減）
        searchReservation.current = setTimeout(() => {
            setSearchValue(value);
        }, 500);
    };

    const handleSelect = (value, option) => {
        const fields = form.getFieldsValue();
        const { targetDetails } = fields;
        Object.assign(targetDetails[name], { app: value });
        form.setFieldsValue({ targetDetails });
        setInput(option.children);
    };

    const handleClear = () => {
        handleSelect(undefined, {});
    };

    const edumallAppList = edumallAppLists[input] || {};
    return (
        <div className='search-target-detail'>
            <Select
                allowClear
                filterOption={false}
                name={name}
                notFoundContent={
                    edumallSearchConnection.meta.fetch ?
                        <span><LoadingOutlined  spin />検索中</span> :
                        <Empty description='アプリがありません' image={Empty.PRESENTED_IMAGE_DEFAULT}/>
                }
                onClear={handleClear}
                onSearch={handleSearch}
                onSelect={handleSelect}
                placeholder='対象を入力してください（例: 「教科書」「算数」など）'
                showArrow={false}
                showSearch
                value={input}
            >
                {edumallAppList.list?.map(term => {
                    return <Option key={term.value} value={term.value}>{term.text}</Option>;
                })}
            </Select>
            <Button
                className='mr-2'
                danger
                icon={<DeleteOutlined/>}
                onClick={onRemove}
                shape='circle'
                size='small'
            />
        </div>
    );
};

export default EduMallSelect;
